/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, percent: NonNullable<unknown> }} Partner_Billing_Board_DiscountInputs */



/**
* | output |
* | --- |
* | "{amount} below list ({percent})" |
*
* @param {Partner_Billing_Board_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_discount = /** @type {((inputs: Partner_Billing_Board_DiscountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_DiscountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} unter Listenpreis (${i?.percent})`)
	return /** @type {LocalizedString} */ (`${i?.amount} below list (${i?.percent})`)
});